<template>
    <div class="small-6 medium-4 large-2 columns">
        <ul v-if="linksModel && linksModel.length > 0">
            <li
                v-if="title && title.Url && title.Text"
                class="footer-header"
            >
                <a
                    :href="title.Url"
                    v-html="title.Text"
                />
            </li>
            <footer-link-list-item
                v-for="(link, index) in linksModel"
                :key="'link-list-item-' + index"
                :link-model="link"
            />
        </ul>
    </div>
</template>

<script>
import FooterLinkListItem from './FooterLinkListItem.vue';

export default {
    name: 'FooterLinkList',
    components: {
        FooterLinkListItem
    },
    props: {
        linksModel: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: Object,
            default() {
                return {
                    Url: '',
                    Text: ''
                };
            }
        }
    }
};
</script>
